<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-circle-plus-outline"
          @click="addPath"
          >新增跟车人员</el-button
        >
      </div>
      <div class="search_box">
        <el-input
          size="mini"
          v-model.trim="requestData.entouragName"
          placeholder="人员名称"
        ></el-input>
        <el-button
          size="mini"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchData"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box">
        <el-table
          :data="tableData"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          v-loading="tableLoading"
        >
          <el-table-column label="序号" width="70" align="center">
            <template slot-scope="scope">
              {{
                requestData.pageSize * (requestData.pageNum - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="entouragName"
            label="姓名"
            align="center"
            width="170"
          >
          </el-table-column>
          <el-table-column
            prop="entouragGender"
            label="性别"
            align="center"
            width="170"
          >
            <template slot-scope="scope">
              {{
                $Common.getDataName(
                  $store.state.select.personnelSex,
                  scope.row.entouragGender
                )
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="chauffeurTypeCertificate"
            label="证件类型"
            align="center"
            width="170"
          >
            <template slot-scope="scope">
              {{
                $Common.getDataName(
                  $store.state.select.certificateTypeTwo,
                  scope.row.entouragTypeCertificate
                )
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="entouragIdNumber"
            label="证件号码"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="entouragDateBirth"
            label="出生日期"
            width="270"
            align="center"
          >
            <template slot-scope="rowData">
              <span v-if="rowData.row.entouragDateBirth">{{
                $Common.dateFormatDate(rowData.row.entouragDateBirth)
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="entouragEmployer"
            label="工作单位"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="entouragPersonnelNature"
            label="人员性质"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="entouragCellphoneNumber"
            label="联系电话"
            align="center"
          >
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="rowData">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="editRowInfo(rowData.row)"
                >编辑</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="delRowInfo(rowData.row.entourageId)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNum"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <bus-follow-dialog
      :showDialog="showDialog"
      :type="infoType"
      :info="rowInfo"
      @saveClick="saveClick"
      @close="close"
    ></bus-follow-dialog>
  </div>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import BusFollowDialog from "./components/BusFollowDialog.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    BusFollowDialog
  },
  props: {},
  data() {
    //这里存放数据
    return {
      requestData: {
        entouragName: "",
        pageNum: 1,
        pageSize: 20,
        schoolId: this.$store.state.schoolId
      },
      tableData: [],
      total: 0,
      tableLoading: false,
      showDialog: false,
      infoType: "add",
      rowInfo: {}
    };
  },
  //监控data中的数据变化
  watch: {},
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    addPath() {
      this.rowInfo = {
        entouragName: "", //姓名
        entouragGender: 0, //性别
        entouragDateBirth: "", //出生日期
        entouragEmployer: "", //工作单位
        entouragTypeCertificate: "", //证件类型
        entouragIdNumber: "", //证件号码
        entouragUnitNature: "", //单位性质
        entouragPersonnelNature: "", //人员性质
        entouragFixedNumber: "", //固定电话
        entouragCellphoneNumber: "", //手机号码
        entouragHomeAddress: "", //家庭住址
        entouragePhoto: "", //头像
        schoolId: this.$store.state.schoolId //学校id
      };
      this.infoType = "add";
      this.showDialog = true;
    },
    editRowInfo(info) {
      this.rowInfo = Object.assign({}, info);
      this.rowInfo.entouragDateBirth = this.rowInfo.entouragDateBirth * 1000;
      this.infoType = "edit";
      this.showDialog = true;
    },
    searchData() {
      this.requestData.pageNum = 1;
      this.getSchoolBulEntourage();
    },
    async getSchoolBulEntourage() {
      this.tableLoading = true;
      let res = await this.$Http.getSchoolBulEntourage(this.requestData);
      this.tableLoading = false;
      if (res.code == 200) {
        this.total = res.data.total || 0;
        this.tableData = res.data.list || [];
      } else if (res.code == 101) {
        this.total = 0;
        this.tableData = [];
      } else {
        this.total = 0;
        this.tableData = [];
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async delRowInfo(id) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await this.$Http.delSchoolBulEntourage({ entourageId: id });
          if (res.code == 200) {
            this.getSchoolBulEntourage();
          } else if (res.code == 101) {
          } else {
            this.$message({
              message: res.messsage,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      this.getSchoolBulEntourage();
    },

    saveClick(info) {
      let obj = Object.assign({}, info);
      if (String(obj.entouragDateBirth).length > 10) {
        obj.entouragDateBirth = obj.entouragDateBirth / 1000;
      }
      this.addOrEditSchoolBulEntourage(obj);
    },
    async addOrEditSchoolBulEntourage(info) {
      var res;
      if (this.infoType == "add") {
        res = await this.$Http.addSchoolBulEntourage(info);
      } else {
        res = await this.$Http.editSchoolBulEntourage(info);
      }
      if (res.code == 200) {
        this.showDialog = false;
        this.getSchoolBulEntourage();
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    close() {
      this.showDialog = false;
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {
    this.getSchoolBulEntourage();
  },
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>
